import React from 'react';
import useStore from '../../../zustand/useStore';

function UR5ePosition() {
    // TCP Position
    const x = useStore(state => state.x_absolute_position);
    const y = useStore(state => state.y_absolute_position);
    const z = useStore(state => state.z_absolute_position);

    // Joint Angles
    const j1 = useStore(state => state.j1);
    const j2 = useStore(state => state.j2);
    const j3 = useStore(state => state.j3);
    const j4 = useStore(state => state.j4);
    const j5 = useStore(state => state.j5);
    const j6 = useStore(state => state.j6);

    const lastUpdateTime = useStore(state => state.lastUpdateTime);

    return (
        <div className='position'>
            <div className='position__table'>
                <span>
                    <p>Position</p>
                    <p>Absolute (m)</p>
                    <p>Joint Angles (rad)</p>
                </span>

                <span>
                    <p>X</p>
                    <p>{parseFloat(x).toFixed(2)}</p>
                    <p>J1: {j1.toFixed(2)}</p>
                    <p>J4: {j4.toFixed(2)}</p>
                </span>
                <span>
                    <p>Y</p>
                    <p>{parseFloat(y).toFixed(2)}</p>
                    <p>J2: {j2.toFixed(2)}</p>
                    <p>J5: {j5.toFixed(2)}</p>
                </span>
                <span>
                    <p>Z</p>
                    <p>{parseFloat(z).toFixed(2)}</p>
                    <p>J3: {j3.toFixed(2)}</p>
                    <p>J6: {j6.toFixed(2)}</p>
                </span>
            </div>
            <p style={{ fontSize: 11, float: 'right' }}>Last Updated Time: {lastUpdateTime}</p>
        </div>
    );
}

export default UR5ePosition;